<app-auth-shell [testimonial]="false">
  @switch (stage()) {
    @case ('email') {
      <app-auth-header
        [title]="'pages.auth.verification.title' | transloco"
        [subtitle]="'pages.auth.verification.subtitle' | transloco" />

      <form [formGroup]="emailForm" (ngSubmit)="sendCode()" novalidate>
        <app-auth-panel>
          <vx-form-field
            [label]="'pages.auth.verification.emailLabel' | transloco">
            <vx-input
              size="lg"
              type="email"
              name="email"
              formControlName="email"
              autocomplete="email" />
          </vx-form-field>

          @if (messages().length) {
            <app-kratos-messages [messages]="messages()" />
          }

          <vx-button
            type="submit"
            size="lg"
            [fullWidth]="true"
            [loading]="step.busy()">
            {{ 'pages.auth.verification.sendCode' | transloco }}
          </vx-button>
        </app-auth-panel>
      </form>
    }

    @case ('code') {
      <app-auth-header
        [title]="'pages.auth.code.title' | transloco"
        [subtitle]="'pages.auth.code.sentTo' | transloco: { email: email() }" />

      <app-auth-panel class="items-center pt-8">
        <app-code-entry
          [step]="step"
          [messages]="messages()"
          (completed)="submitCode($event)" />
      </app-auth-panel>

      <app-code-resend
        class="mt-5"
        [resendIn]="cooldown.remaining()"
        [busy]="step.busy()"
        (resend)="resend()"
        (changeEmail)="changeEmail()" />
    }

    @case ('done') {
      <app-auth-header
        [title]="'pages.auth.verification.done.title' | transloco"
        [subtitle]="'pages.auth.verification.done.subtitle' | transloco" />

      <vx-button class="mt-8" size="lg" [fullWidth]="true" (click)="continue()">
        {{ 'pages.auth.verification.done.continue' | transloco }}
      </vx-button>
    }
  }

  @if (failed()) {
    <p
      class="mt-5 text-center text-13 tracking-tight text-danger-400"
      role="alert">
      {{ 'pages.auth.verification.failed' | transloco }}
    </p>
  }

  <app-auth-help />
</app-auth-shell>
